<div class="settings-container">
    <div class="settings-container__header flex-row-center"> 
        <span class="B flex-1 m-t5">Settings</span>
        <div class="flex-row-container" >
            <!-- <button mat-stroked-button color="primary" class="B m-l10 font14" style="height:35px" (click)="onHideSettings()">Cancel</button> -->
            <button mat-stroked-button color="primary" class="m-l10 font16" style="height:35px" [ngClass]="isDataChanged?'highlight-bg':''" [disabled]="!form.valid" (click)="saveSettings()">Save</button>            
            <mat-icon class="m-l10 m-t5 pointer  flex-col-end" (click)="onHideSettings()">close</mat-icon>
        </div>  
        
    </div>
    <div class="settings-container__content flex-col-container">
        <!-- <p *ngIf="!isSettingsAvailable" class="blueText14 flex-1">{{errorMsg}}</p> -->
        <div class="flex-1">
            <form [formGroup]="form">
            <mat-accordion multi>
                <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">CURRENT $ Vs. FUTURE $</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>                    
                    <div class="flex-row-container">
                        <gp-pvfv-setting class="font14" [ViewBy]="planResultViewBy" (onChangeSetting)="onChangePVFVSettings($event)"></gp-pvfv-setting>
                    </div>                    
                </mat-expansion-panel> 
                <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">INFLATION & DISCOUNT RATES</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Inflation: </span>
                        <div class="flex-1"></div>
                        <mat-form-field                  
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'infRate'" 
                            placeholder="" 
                            aria-label="Inflation Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Discount Rate: </span>
                        <div class="flex-1"></div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'discountRate'" 
                            placeholder="" 
                            aria-label="Discount Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                </mat-expansion-panel> 
                <!-- <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">DISCOUNT RATE</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'discountRate'" 
                            placeholder="" 
                            aria-label="Discount Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                </mat-expansion-panel>  -->
                <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">PRE-RETIREMENT TAX RATES</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Income Tax Rate:</span>
                        <div class="flex-1"></div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'preIncTaxRate'" 
                            placeholder="" 
                            aria-label="Pre-retirment Income Tax Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Capital Gain Tax Rate:</span>
                        <div class="flex-1"></div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'preCGTaxRate'" 
                            placeholder="" 
                            aria-label="Pre-retirement Income Tax Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                    
                </mat-expansion-panel> 
                <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">POST-RETIREMENT TAX RATES</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Income Tax Rate:</span>
                        <div class="flex-1"></div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'postIncTaxRate'" 
                            placeholder="" 
                            aria-label="Post-retirment Income Tax Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                    <div class="flex-row-container">
                        <span class="m-r8 m-t7 flex-col-end font16">Capital Gain Tax Rate:</span>
                        <div class="flex-1"></div>
                        <mat-form-field class=""                 
                            style="width:60px;  border-top:0px !important; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'postCGTaxRate'" 
                            placeholder="" 
                            aria-label="Post-retirement Income Tax Rate" 
                            maxlength="6"  
                            decimals="2"                  
                            NumbersOnly                        
                            class="ip-right-align"/>                
                        </mat-form-field> 
                    </div>
                </mat-expansion-panel> 
                <mat-expansion-panel expanded='true' class="m-t5"> 
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="B">EXPENDITURE SPENDING PATTERN</div>    
                        </mat-panel-title>
                    </mat-expansion-panel-header>                    
                    <div class="flex-row-container">
                        <mat-button-toggle-group [formControlName]="'expSpendingPattern'">
                            <mat-button-toggle class="font14" style="width:50px" value='Y'>Yes</mat-button-toggle>
                            <mat-button-toggle class="font14" style="width:50px" value='N'>No</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>                    
                </mat-expansion-panel> 
            </mat-accordion>
            </form>
        </div>                         
        <!-- <mat-divider class="divider"></mat-divider>
        <div class="flex-row-end m-t15" >
            <button mat-raised-button color="basic" (click)="onHideSettings()" class="m-l10">Cancel</button>
            <button mat-raised-button (click)="saveSettings()" class="saveButton m-l10">Save</button>            
        </div>         -->
    </div>    
</div>